"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasicAuthProfile = void 0;
class BasicAuthProfile {
    constructor(username, password) {
        this.headers = { Authorization: getBasicAuthHeader(username, password) };
    }
    getAuthHeaders() {
        return { ...this.headers };
    }
}
exports.BasicAuthProfile = BasicAuthProfile;
function getBasicAuthHeader(username, password) {
    return `Basic ${getEncodedCredentials(username, password)}`;
}
function getEncodedCredentials(username, password) {
    return toBase64(`${username}:${password}`);
}
function toBase64(input) {
    return Buffer.from(input).toString('base64');
}
//# sourceMappingURL=basic-auth.profile.js.map